import styled from 'styled-components';

export const MainPage = styled.main`
  display: flex;
  flex-direction: column;
  color: white;
  font-family: 'Roboto', sans-serif;

  padding-bottom: 20%;
`;

export const Line = styled.hr`
  border-top: 1px solid #7070705A;
  border-bottom: none;
`;
